module.exports = __webpack_public_path__ + "static/History Map-d05f082b859ed46aa728e67b795ec171.jpg";